import { useState } from "react"
import { MapPin, Clock, Phone, Mail, ChevronDown, ChevronUp } from "lucide-react"

export default function AboutUs() {
  return (
    <div className="bg-white min-h-screen">
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Our Story</h2>
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="md:w-1/2">
              <img
                src="https://media.istockphoto.com/id/870915532/photo/man-holding-crate-ob-fresh-vegetables.jpg?s=612x612&w=0&k=20&c=k2dXOI-wxUy7lX77Pm90vU6TJXmAAv5VtK60ZZHIyCA="
                alt="Fresh Market history"
                className="rounded-lg shadow-lg w-full h-auto"
              />
            </div>
            <div className="md:w-1/2">
              <h3 className="text-2xl font-semibold mb-4 text-newblue">Rooted in Community</h3>
              <p className="text-gray-700 mb-4">
At Food Universe, our story started simply: one small store, one family, and a passion for bringing quality food to the people in our neighborhood. What began as a single location has grown into a beloved chain, but through every step of that journey, we've never lost sight of what matters most.
              </p>
              <p className="text-gray-700 mb-4">
        As a family-owned business, serving our community is at the core of everything we do. Our friendly staff goes above and beyond to make every visit feel warm and welcoming, because to us, every customer who walks through our doors is a neighbor worth knowing.
              </p>
              <p className="text-gray-700">
                We've grown over the years, but our values haven't changed. We're still the same store at heart, just with a lot more neighbors to serve. Whether you're stopping in for a quick errand or your weekly haul, Food Universe is here for you. Thank you for being part of our story.

              </p>
            </div>
          </div>
        </div>
        
      </section>
    </div>
  )
}

